import Component from './Component'
import Skeleton from './Skeleton'

type TransactionRecordComponentInterface = typeof Component

interface TransactionRecordInterface extends TransactionRecordComponentInterface {
  Skeleton: typeof Skeleton
}

const TransactionRecord = Component as TransactionRecordInterface
TransactionRecord.Skeleton = Skeleton

export default TransactionRecord